import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const getBlogPosts = () => api.get("/blog").then((r) => r.data);
export const getBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const getTeam = () => api.get("/team").then((r) => r.data);
export const getCareers = () => api.get("/careers").then((r) => r.data);
export const submitContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);
